import type {
    CallPlayerConfig,
    PlayerConfigCommon,
    StreamingProvider,
} from '$lib/services/streaming/types';
import type { BroadcastConfig } from '$lib/services/streaming/types';

import { StreamProvider } from '@shared/types/room';

import { Broadcaster } from './broadcaster';
import { Player } from './player';

export default class CloudflareCalls implements StreamingProvider {

    private broadcaster = new Broadcaster();
    private player = new Player();
    private broadcastConfig?: BroadcastConfig;

    public getType() {
        return StreamProvider.CloudFlareCalls;
    }

    public async startBroadcast(config: BroadcastConfig) {
        this.broadcastConfig = config;
        return this.broadcaster.startBroadcast(config);
    }

    public stopBroadcast() {
        return this.broadcaster.stopBroadcast();
    }

    public startDelivery(config: CallPlayerConfig & PlayerConfigCommon) {
        return this.player.startDelivery(config);
    }

    public stopDelivery() {
        return this.player.stopDelivery();
    }

    public destroy() {
        this.stopDelivery();
        this.stopBroadcast();
    }

    public restartBroadcast() {
        this.stopBroadcast();
        if (this.broadcastConfig) {
            this.startBroadcast(this.broadcastConfig);
        }
    }

}